<template>
  <slice
    :id="block._key"
    class="slice--cta-image"
    :class="[
      block.is_full ? 'full' : 'container',
      block.has_sibbling ? 'has-sibbling' : '',
      `text--${block.text_position}`,
      !block.image.darken_image ? 'no-shadow' : '',
    ]"
  >
    <div class="row-md justify-center">
      <div :class="block.is_full ? 'col-md-12' : 'col-md-10 col-xlg-12'">
        <component
          :is="linkComponent(block.link)"
          :to="url"
          :href="url"
          data-cy-link
          class="d-block"
          @click.native="activateLoading"
        >
          <div v-if="firstSlice" class="slice__image p-relative" data-cy-image>
            <image-simple
              :image="image"
              provider="sanity"
              class="d-none d-md-block"
            />
            <image-simple
              :image="imageMobile"
              provider="sanity"
              :widths="[320, 414, 640, 769]"
              class="d-md-none"
            />
          </div>
          <div v-else class="slice__image p-relative" data-cy-image>
            <lazy-image
              ref="imageDesktop"
              :image="image"
              provider="sanity"
              class="d-none d-md-block"
            />
            <lazy-image
              :image="imageMobile"
              :widths="[320, 414, 640, 769]"
              provider="sanity"
              class="d-md-none"
            />
          </div>

          <cta-content :block="block" :loading-button="loadingButton" />
        </component>
      </div>
    </div>
  </slice>
</template>

<script>
import CtaContent from './cta/CtaContent'

import Slice from '@/components/Slices/Slice'
import PortableText from '@/components/RichText/PortableText'
import PrimaryButton from '@/components/buttons/Primary'
import ImageSimple from '@/components/Image/ImageSimple'
import LazyImage from '@/components/Image/LazyImage'
import { getSanityBunnyImageLink } from '@/utils/image'

export default {
  name: 'BlockCtaImage',
  components: {
    Slice,
    PortableText,
    PrimaryButton,
    ImageSimple,
    LazyImage,
    CtaContent,
  },
  props: {
    block: { type: Object, required: true },
    firstSlice: { type: Boolean, default: false },
  },
  data: () => ({ loadingButton: false }),
  computed: {
    image() {
      if (this.block.is_full) {
        if (this.block.has_sibbling) {
          return {
            url: getSanityBunnyImageLink(this.block.image.image, {
              width: 720,
              height: 640,
            }),
            dimensions: {
              width: 720,
              height: 640,
            },
          }
        }

        return {
          url: getSanityBunnyImageLink(this.block.image.image, {
            width: 2000,
            height: 1060,
          }),
          dimensions: {
            width: 2000,
            height: 1060,
          },
        }
      }

      return {
        url: getSanityBunnyImageLink(this.block.image.image, {
          width: 1200,
          height: 400,
        }),
        dimensions: {
          width: 1200,
          height: 400,
        },
      }
    },
    imageMobile() {
      if (this.block.is_full) {
        if (this.block.has_sibbling) {
          return {
            url: getSanityBunnyImageLink(
              this.block.image.image_mobile || this.block.image.image,
              {
                width: 480,
                height: 480,
              }
            ),
            dimensions: {
              width: 480,
              height: 480,
            },
          }
        }
        return {
          url: getSanityBunnyImageLink(
            this.block.image.image_mobile || this.block.image.image,
            {
              width: 360,
              height: 800,
            }
          ),
          dimensions: {
            width: 360,
            height: 800,
          },
        }
      }

      return {
        url: getSanityBunnyImageLink(
          this.block.image.image_mobile || this.block.image.image,
          {
            width: 345,
            height: 400,
          }
        ),
        dimensions: {
          width: 345,
          height: 400,
        },
      }
    },
    url() {
      if (this.block.link.type === 'external') {
        return this.block.link.url
      }

      return this.$contextSanityPath(this.block.link.internalLink)
    },
  },
  methods: {
    activateLoading() {
      this.loadingButton = true
    },
    linkComponent(link) {
      return link.type === 'external' ? 'a' : 'nuxt-link'
    },
  },
}
</script>

<style lang="scss">
.slice--cta-image {
  .slice__image {
    background: black;

    > * {
      opacity: 0.6;
    }
  }

  &.no-shadow {
    .slice__image > * {
      opacity: 1;
    }
  }

  &.full {
    .slice__image {
      .lazy-image,
      .image--simple {
        padding-top: 0 !important;
        height: 100svh;

        > img {
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          object-fit: cover;
          object-position: center;
          max-width: none;
        }
      }

      .image--simple {
        overflow: hidden;
      }
    }
  }
}
</style>
